import { render, staticRenderFns } from "./USGBC.vue?vue&type=template&id=11f27865&"
import script from "./USGBC.vue?vue&type=script&lang=ts&"
export * from "./USGBC.vue?vue&type=script&lang=ts&"
import style0 from "./USGBC.vue?vue&type=style&index=0&id=11f27865&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports